import clsx from 'clsx';
import { FormattedNumber } from 'react-intl';

type MarginValueProps = {
  value: number;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  isEditable: boolean;
  'data-e2e'?: string;
};

export const MarginValue = (props: MarginValueProps) => {
  const { value, minimumFractionDigits, maximumFractionDigits, isEditable, 'data-e2e': dataE2e } = props;

  return (
    <span
      className={clsx('fw-bold flex-fill text-center', {
        'text-success': isEditable && value >= 0,
        'text-danger': isEditable && value < 0,
        'text-light': !isEditable,
      })}
      data-e2e={dataE2e}
    >
      <FormattedNumber
        value={value}
        signDisplay="exceptZero"
        minimumFractionDigits={minimumFractionDigits}
        maximumFractionDigits={maximumFractionDigits}
        notation={'compact'}
      />
    </span>
  );
};
